import React, { useState } from 'react';
import PasswordGate from '../components/password-gate/password-gate'

export const themeContext = React.createContext();

const Provider = props => {
    const [darkMode, setDarkMode] = useState(localStorage !== undefined ? (localStorage.getItem('rpModeSetting') || false) : false);

    const toggleDarkMode = (mode) => {
        const setting = !mode;
        setDarkMode(setting);
        if (localStorage !== undefined) {
            localStorage.setItem('rpModeSetting', setting);
        }
    }

    return (
        <PasswordGate>
            <themeContext.Provider value={{
                darkMode,
                changeThemeMode: () => toggleDarkMode(darkMode)
            }}>
                {props.children}
            </themeContext.Provider>
        </PasswordGate>
    )
}

export default ({ element }) => (
    <Provider>
      {element}
    </Provider>
);